export const matchPath = (path, options) => {
    const pathName = options.basePath || currentPath();

    if (options.exact) {
        // exact match, i.e. for root items
        return pathName === path;
    }

    if (options.strict) {
        // fuzzy match, i.e. for paths with parameters
        return pathName.indexOf(path) === 0;
    }

    // loose match, i.e. for parts of the paths matching
    return pathName.indexOf(path) >= 0;
};

export const findRoute = (routes, onNestingNode) => {
    for (let route of routes) {
        // Check and match route href.
        if (route.href && matchPath(route.href, route)) {
            return route;
        }

        if (route.items) {
            // Recursively checking child elements.
            const result = findRoute(route.items, onNestingNode);

            if (result) {
                // Callback when nesting deeper.
                onNestingNode && onNestingNode(route);

                return result;
            }
        }
    }

    // No route found.
    return null;
};

export const currentPath = () => {
    return window.location.href.replace(/\/$/, '');
};